import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Customer} from "../models/customer";
import {CustomerList} from "../models/customer-list";
import {environment} from "../../../../../environments/environment";
import {CustomerFileUploadRequest} from "../models/customer-file-upload-request";
import {CsvFileValidateResponse} from "../models/csv-file-validate-response";
import {CustomerFileUploadResponse} from "../models/customer-file-upload-response";
import {CustomerGroup, CustomerGroupRequest} from "../models/customer-group";

@Injectable({
    providedIn: 'root'
})
export class CustomerService {
    constructor(private http: HttpClient) {
    }


    getAllCustomer(locationId: string, customerNamePattern: string, pageNumber: number, options?: { ungroupedOnly?: boolean }) {
        let url = `${environment.BASE_URL}customer/getAllCustomers?customerNamePattern=${encodeURIComponent(customerNamePattern)}&locationId=${locationId}&pageNumber=${pageNumber}`;
        if (options?.ungroupedOnly) {
            url += '&ungroupedOnly=true';
        }
        return this.http.get<Customer>(url);
    }

    getAllCustomersByCustomerListId(locationId: string, customerListId: string, pageNumber: number) {
        return this.http.get<Customer>(`${environment.BASE_URL}customer/getAllCustomersByCustomerListId?customerListId=${customerListId}&locationId=${locationId}&pageNumber=${pageNumber}`);
    }

    createOrFetchCustomer(customerRequestObj: any) {
        // Backend may return 200 with an empty body; default JSON parsing would fail and skip UI refresh.
        return this.http.post(`${environment.BASE_URL}customer/createOrFetchCustomer`, customerRequestObj, {responseType: 'text'});
    }

    getAllCustomerList(locationId: string, listNamePattern: string, pageNumber: number) {
        return this.http.post<CustomerList>(`${environment.BASE_URL}customerList/getAllCustomerList?pageNumber=${pageNumber}`, {
            locationId,
            listNamePattern
        });

    }

    validateCsvFile(locationId: string, customerListName: string, formData: FormData) {
        return this.http.post<CsvFileValidateResponse>(`${environment.BASE_URL}customerList/validateCsvFile/${locationId}/${customerListName}`, formData);
    }

    updateCsvFile(locationId: string, customerListId: string, formData: FormData) {
        return this.http.post<CsvFileValidateResponse>(`${environment.BASE_URL}customerList/updateCsvFile/${locationId}/${customerListId}`, formData);
    }

    uploadCustomerList(customerFileUploadRequest: CustomerFileUploadRequest) {
        return this.http.post<CustomerFileUploadResponse>(`${environment.BASE_URL}customerList/uploadCustomerList`, customerFileUploadRequest);
    }

    updateCustomer(customerRequestObj: any) {
        return this.http.patch(`${environment.BASE_URL}customer/updateCustomer`, customerRequestObj);
    }

    modifyStatus(customerIds: string[], value: boolean, type: string='hotlist') {
        return this.http.put(`${environment.BASE_URL}customer/modifyStatus`, {customerIds, type, value});
    }

    getAllCustomerGroups(locationId: string, orgId: string) {
        return this.http.get<CustomerGroup[]>(`${environment.BASE_URL}customerGroup?locationId=${locationId}&orgId=${orgId}`);
    }

    syncCustomerGroupsFromGp(locationId: string) {
        return this.http.post<CustomerGroup[]>(`${environment.BASE_URL}customerGroup/sync/gp?locationId=${locationId}`, {});
    }

    getCustomerGroup(customerGroupId: string) {
        return this.http.get<CustomerGroup>(`${environment.BASE_URL}customerGroup/${customerGroupId}`);
    }

    createCustomerGroup(request: CustomerGroupRequest) {
        return this.http.post<CustomerGroup>(`${environment.BASE_URL}customerGroup`, request);
    }

    updateCustomerGroup(request: CustomerGroupRequest) {
        return this.http.put<CustomerGroup>(`${environment.BASE_URL}customerGroup`, request);
    }

    getCustomersByCustomerGroupIds(customerGroupIds: string[], locationId: string, pageNumber = 0, customerNamePattern?: string) {
        const idsParam = customerGroupIds.map(id => `customerGroupIds=${encodeURIComponent(id)}`).join('&');
        let url = `${environment.BASE_URL}customer/getAllCustomersByCustomerGroupIds?${idsParam}&locationId=${locationId}&pageNumber=${pageNumber}`;
        if (customerNamePattern) {
            url += `&customerNamePattern=${encodeURIComponent(customerNamePattern)}`;
        }
        return this.http.get<Customer>(url);
    }

}
